import selectEntityItem from "./entityItem"

export default function selectData(state, model, id, byDefault = null) {
  const entityItemState = selectEntityItem(state, model, id)
  return entityItemState ? entityItemState.data : byDefault
}
